const states = {
  downtime_details: {
    downtime_list: [],
    downtime_loading: false,
    downtime_load_error: false
  }
}

export default states
